import { Component, h, Host, Event, EventEmitter, Method, Prop } from '@stencil/core';
import { v4 as uuidv4 } from 'uuid';
import { Notification } from '../../types/Notification';
import { IconSize } from '../icon/icon';

const iconMap = new Map();
iconMap.set('warning', 'alert-circle');
iconMap.set('info', 'info');
iconMap.set('error', 'alert-triangle');
iconMap.set('success', 'check-circle');

@Component({
  tag: 'anchor-notification-banner',
  styleUrl: './notification-banner.scss',
  shadow: true,
})
export class NotificationBanner {
  /**
   *  Give this instance of notification-inline a custom ID, or keep the default.
   */
  @Prop({}) uuid: string = uuidv4();

  /**
   * The type of notification to be displayed. Options are Error, Info, Success, and Warning.
   */
  @Prop({ reflect: true, mutable: true }) type: Notification;

  @Prop({ reflect: true, mutable: true }) canClose?: boolean = true;

  @Prop({ reflect: true, mutable: true }) iconSize?: IconSize = 'small';

  @Event() closed: EventEmitter;

  @Method()
  async close() {
    this.closed.emit(true);
  }

  render() {
    return (
      <Host>
        <div
          id={this.uuid}
          class={{
            'anchor-c-notification-banner': true,
            [this.type]: true,
          }}
        >
          <anchor-icon name={iconMap.get(this.type)} class="anchor-c-notification-banner__icon" size={this.iconSize}></anchor-icon>
          <div class="anchor-c-notification-banner__text">
            <slot name="header"></slot>
            <slot></slot>
            <slot name="link"></slot>
          </div>
          {this.canClose && (
            <anchor-icon-button class="anchor-c-notification-banner__close-icon" theme="default" title="Close" onClick={() => this.close()}>
              <anchor-icon slot="icon" name="x" size="small"></anchor-icon>
            </anchor-icon-button>
          )}
        </div>
      </Host>
    );
  }
}
